<template>
  <div class="domestic-transport-main">
    <div class="domestic-transport" >
      <div class="domestic-transport_cards">
        <div class="domestic-transport_cards-title">
     
          <div class="domestic-transport_cards-title-meta">
            <img
              class="domestic-transport_cards-title-meta-photo"
              v-lazy="
                require(`@/assets/images/core-service/domestic-transport-1.png`)
              "
              alt=""
            />
          </div>
        </div>
      </div>
    </div>

    <div class="domestic-transport-text">
      <div class="domestic-transport-text-blog-card">
        <div class="domestic-transport-text-blog-card-text">
          <div>
            <h2 class="domestic-transport-text-blog-card-text-title">Multi-modal transport (LTL) 
</h2>
            <p class="domestic-transport-text-blog-card-text-description">
          
For inland transport solutions at Vietnam, we plan and choose from a range of transportation options to arrive at the most efficient combination for speed and cost efficiency. 
Providing multi-modal Inland transportation service (Truck - Sea - Truck) 
            </p>
            <p class="domestic-transport-text-blog-card-text-description">
             We help you with: 
              <ul>
                <li>
               Our special expertise in handling for better safety and handling of cargo. 
                </li>
                  <li>
               Vast presence that helps with necessary permits and clearances.  
                </li>
                  <li>
               Support services and escorts wherever necessary.
                </li>
                  <li>
               Compliance with all regulatory codes and standards.
                </li>
                  <li>
                Consolidate Inland LCL by sea route with added value services (palletizing, wooden crate packing, tallying when delivery) 
                </li>              

                </ul>
            </p>

            <div class="domestic-transport-text-blog-card-text-description">Frequency: 2 routes of weekly <br/>Fast transit time with right schedule <br/>Competitive prices and incentives <br/>
            Save, avoid lost and damage </br>Commit for cargo insurance</div>
         
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
<style lang="scss" scoped>
.domestic-transport-main {
  position: relative;

  @media (min-width: 1024px) {
    &:nth-child(1) {
      &::after {
        content: "";
        position: absolute;
        top: 15%;
        transform: translate(0, -50%);
        right: -80px;
        background-image: url("../../../../../assets/images/core-service/core-top.png");
        background-size: 300px 300px;
        display: inline-block;
        width: 300px;
        height: 300px;
      }
      &::before {
        content: "";
        position: absolute;
        bottom: 800px;
        left: -120px;
        background-image: url("../../../../../assets/images/core-service/core-bottom.png");
        background-size: 300px 300px;
        display: inline-block;
        width: 300px;
        height: 300px;
      }
    }
  }

  .domestic-transport {
    @media (min-width: 900px) {
      padding: 70px 70px;
    }
    @media (min-width: 1024px) {
      padding: 70px 230px;
    }
    @media (min-width: 1900px) {
      padding: 100px 470px;
    }
    &_cards {
      padding: 40px;

      @media (min-width: 900px) {
        padding-left: 0;
      }
      &-title {
        color: var(--text-normal-color);
        font-style: var(--normal-font-size);
        font-weight: 400;
        &-meta {
          &-photo {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
    }
  }

  .domestic-transport-text {
    @media (min-width: 900px) {
      padding: 40px 70px 70px;
    }
    @media (min-width: 1024px) {
      padding: 40px 70px 230px;
    }
    @media (min-width: 1900px) {
      padding: 100px 470px;
    }
    background-color: var(--bg-color-2);

    &-blog-card {
      &-text {
        padding: 30px;
        display: flex;
        flex-direction: column;
        gap: 30px;
        &-title {
          color: var(--primary-color);
          margin-bottom: 20px;
          font-style: var(--big-font-size);
          font-weight: 700;
        }
        &-description {
          color: var(--text-normal-color);
          font-style: var(--normal-font-size);
          font-weight: 400;
          ul {
            li {
              list-style: none !important;
              &::before {
                content: "\2022";
                color: #2b938c;
                font-weight: bold;
                display: inline-block;
                font-size: 20px;
                width: 1em;
                margin-left: -1.5em;
                margin-right: -10px;
              }
            }
          }
        }
      }
    }
  }
}
</style>